import { r } from '@/api/api-utils';
import { crmHooks, loginHooks } from '@/api/api-option-hooks';
const api = {
  common: {
    getValidateCode: r('GET bff/api/v1/common/validatecode', false, crmHooks),
  },
  contact: {
    sendEmail: r('POST api/sitecore/Lead/SendEmail', false, crmHooks),
    sendCustomerEmail: r('POST bff/api/v1/customer/probio/email/send', false, crmHooks),
    submit: r('POST bff/api/v1/customer/probio/contact', false, crmHooks),
  },
  unsubscribe: {
    sendCode: r('POST bff/api/v1/customer/probio/subscribe/send_code', false, crmHooks),
    verifyCode: r('POST bff/api/v1/customer/probio/subscribe/verify_code', false, crmHooks),
    submit: r('PUT bff/api/v1/customer/probio/unsubscribe', false, crmHooks),
  },
  downloadResource: {
    submitOnlineMessage: r('POST bff/api/v1/customer/probio/online_message', false, crmHooks),
  },
  documents: {
    getDocuments: r('GET api/sitecore/customer/getdocuments', false, crmHooks),
  },
  news: {
    getNews: r('GET api/sitecore/customer/getnews', false, crmHooks),
    getNewsDetail: r('GET api/sitecore/customer/getprevnext', false, crmHooks),
  },
  articles: {
    getArticles: r('GET api/sitecore/customer/getarticles', false, crmHooks),
  },
  webinars: {
    getWebinars: r('GET api/sitecore/customer/getwebinars', false, crmHooks),
  },
  search: {
    getSearch: r('GET bff/api/v1/search/probio/es/search', false, crmHooks),
  },
  siteMap: {
    getSiteMap: r('GET api/sitecore/customer/getsitemap', false, crmHooks),
  },
  faq: {
    getFaq: r('GET api/sitecore/customer/getfaqs', false, crmHooks),
  },
  events: {
    getEvents: r('GET api/sitecore/customer/getevents', false, crmHooks),
  },
  videos: {
    getVideos: r('GET api/sitecore/customer/getvideos', false, crmHooks),
  },
};
export default api;
